import React, { useEffect } from "react";
import { Table, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import ConvertMeasurement from "../../../../components/Math/Conversion/ConvertMeasurement";
import { ImperialUnits, MetricUnits } from "../../../../components/Math/Units/AllUnits";
import { useGetBohrkronenQuery } from "../../../../services/API/titanApi";
import { selectedCarryingElement } from "../../../../store/slices/aashtoSlice";
import { selectIsMetric } from "../../../../store/slices/settingsSlice";

function DraggableTableDrillbits({ show, setShow }) {
  const { t } = useTranslation("translation");
  const nodeRef = React.useRef(null);
  const tragglied = useSelector(selectedCarryingElement);
  const { data: bohrkronen } = useGetBohrkronenQuery();
  const isMetric = useSelector(selectIsMetric);

  function findArrayElement(name) {
    return bohrkronen?.find((element) => {
      return element.tragglied_name == name;
    });
  }

  function convert(value) {
    if (!value) {
      return;
    }

    if (value === " ") return value;

    let displayValue = Number(value);

    if (!isMetric) {
      return ConvertMeasurement({
        userInput: displayValue,
        from: MetricUnits.Millimetre,
        to: ImperialUnits.Inch,
      }).toFixed(2);
    }

    return displayValue;
  }

  function renderCells(max_length, myObjects, color) {
    let result = [];
    for (let i = 0; i < max_length; i++) {
      let item = (i < myObjects?.length ?? 0) ? myObjects[i] : " ";
      result.push(
        <CenteredCell className={color} key={i}>
          {convert(item)}
        </CenteredCell>
      );
    }
    return result;
  }
  const bohrkronenElement = findArrayElement(tragglied.name);

  const { nichtbindiger_boden, bindiger_boden, fels } = bohrkronenElement ?? {
    bindiger_boden: {},
    nichtbindiger_boden: {},
    fels: {},
  };

  const { adapter_length, standard_length } = {
    adapter_length: Math.max(
      2,
      nichtbindiger_boden?.adapter?.length ?? 2,
      bindiger_boden?.adapter?.length ?? 2,
      fels?.adapter?.length ?? 2
    ),
    standard_length: Math.max(
      2,
      nichtbindiger_boden?.standard?.length ?? 2,
      bindiger_boden?.standard?.length ?? 2,
      fels?.standard?.length ?? 2
    ),
  };

  useEffect(() => {
    findArrayElement(tragglied.name);
  }, [tragglied]);

  return (
    <Draggable nodeRef={nodeRef} defaultPosition={{ x: 0, y: -200 }}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header>
          <strong className="mx-auto">{t("aeussre.drillBitDiameter")}</strong>
        </Toast.Header>
        <Toast.Body>
          <Table borderless hover responsive size="sm" style={{ tableLayout: "auto" }}>
            <thead>
              <tr className="table-active">
                <CenteredHeadline colSpan={2}>{bohrkronenElement?.tragglied_name}</CenteredHeadline>
                <CenteredHeadline className="green" colSpan={standard_length}>
                  {t("drillBits.standard")}
                </CenteredHeadline>
                <CenteredHeadline className="red" colSpan={adapter_length}>
                  {t("drillBits.withAdapter")}
                </CenteredHeadline>
              </tr>
            </thead>
            <tbody>
              <tr>
                <CenteredCell>{t("drillBits.cohesiveSoils")}</CenteredCell>
                <CenteredCell>{t("drillBits.claydrillbit")}</CenteredCell>
                {renderCells(standard_length, bohrkronenElement?.bindiger_boden?.standard, "green")}
                {renderCells(adapter_length, bohrkronenElement?.bindiger_boden?.adapter, "red")}
              </tr>
              <tr>
                <CenteredCell>{t("drillBits.granularSoils")}</CenteredCell>
                <CenteredCell>{t("drillBits.crosscutdrillbit")}</CenteredCell>
                {renderCells(
                  standard_length,
                  bohrkronenElement?.nichtbindiger_boden?.standard,
                  "green"
                )}
                {renderCells(
                  adapter_length,
                  bohrkronenElement?.nichtbindiger_boden?.adapter,
                  "red"
                )}
              </tr>
              <tr>
                <CenteredCell>{t("drillBits.rocks")}</CenteredCell>
                <CenteredCell>{t("drillBits.carbidedrillbit")}</CenteredCell>
                {renderCells(standard_length, bohrkronenElement?.fels?.standard, "green")}
                {renderCells(adapter_length, bohrkronenElement?.fels?.adapter, "red")}
              </tr>
            </tbody>
          </Table>
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}

export default DraggableTableDrillbits;

export const CenteredHeadline = styled.th`
  && {
    text-align: center;
    vertical-align: middle;
  }
`;

export const CenteredCell = styled.td`
  && {
    text-align: center;
    vertical-align: middle;
  }
`;
